<header class="section page header smart-business-header">
  <div class="shape-wrapper">
    <img
      src="assets/img/v6/header/bg-shape.svg"
      class="main-background img-responsive"
      alt=""
    />
    <div class="shape shape-background shape-top center-xy"></div>
    <div class="shape shape-background shape-right"></div>
  </div>

  <div class="container overflow-hidden">
    <div class="row gap-y">
      <div class="col-md-7">
        <p class="regular small text-uppercase text-secondary">
          innovative solutions for the demanding customer
        </p>
        <h1 class="extra-bold display-md-3 font-md">
          DashCore <span class="d-block light">Smart business</span>
        </h1>
        <p class="lead">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab dolore
          excepturi explicabo, harum in laudantium nulla officiis reprehenderit!
        </p>

        <nav class="nav mt-5">
          <a
            [routerLink]="['/pricing']"
            class="nav-link mr-3 btn btn btn-rounded btn-outline-info bw-2"
          >
            <fa-icon [icon]="tag" [class]="'mr-3'"></fa-icon> Plans & pricing
          </a>

          <a
            [routerLink]="['/auth/register']"
            class="nav-link btn btn-rounded btn-primary bw-2"
          >
            Start now
          </a>
        </nav>
      </div>
    </div>
  </div>

  <div class="main-shape-wrapper">
    <div data-aos="fade-left" data-aos-delay="300">
      <img
        src="assets/img/v6/header/main-shape.svg"
        class="img-responsive main-shape"
        alt=""
      />
      <img
        src="assets/img/v6/header/anim-1.svg"
        class="anim anim-1 floating"
        alt=""
      />
      <img
        src="assets/img/v6/header/anim-1.svg"
        class="anim anim-2 floating"
        alt=""
      />
      <img
        src="assets/img/v6/header/anim-1.svg"
        class="anim anim-3 floating"
        alt=""
      />
    </div>
  </div>
</header>
